import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import mixpanelService from 'services/mixpanelService';
import useGetMixpanelProps from 'hooks/useGetMixpanelProps';
import { getMixpanelErrorProps } from 'axiosUtils';
import { ErrorViewedProps } from 'models/MixpanelEvents';
import { MINUTE } from 'data/global';

export const FILE_CONTENT_QUERY_KEY = 'file-content';
const CONTENT_CACHE_TIME = 30 * MINUTE; // 30 min

type UseFileContentQueryProps = {
  nodeId: string;
  url?: string;
  version?: number;
  enabled?: boolean;
};

export default function useFileContentQuery({
  nodeId,
  url,
  version,
  enabled = true,
}: UseFileContentQueryProps) {
  const getMixpanelProps = useGetMixpanelProps();

  return useQuery<Blob>({
    queryKey: [FILE_CONTENT_QUERY_KEY, { nodeId, version }],
    queryFn: async () => {
      // bare axios (no app interceptors/auth) since `url` is a pre-signed storage url
      const { data } = await axios.get<Blob>(url, { responseType: 'blob' });

      return data;
    },
    onError: (error) =>
      mixpanelService.errorViewed(
        getMixpanelProps(getMixpanelErrorProps(error)) as ErrorViewedProps,
      ),
    enabled: enabled && !!url && !!nodeId,
    staleTime: CONTENT_CACHE_TIME,
    cacheTime: CONTENT_CACHE_TIME,
  });
}
